import { isEmpty } from 'lodash';

const getTaskHistoryResponse = (response, previousResponse, page) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const currentPage = response?.currentPage ?? 1;

  let tasks = response?.isDataExist ? response?.data : [];

  if (!isEmpty(previousResponse) && page !== 1) {
    tasks = [...previousResponse, ...tasks];
  }

  return {
    tasks,
    totalData,
    totalPage,
    currentPage,
  };
};

export default getTaskHistoryResponse;
